var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import { UiIncremental } from '@claims-ia/design-system';
import { WINDOW_COUNT_TITLE } from '@declaration/constants/externalDamages';
import { WindowComponent } from '@declaration/components/externalDamage/DamageDescription/Window/WindowComponent';
let WindowCount = class WindowCount extends WindowComponent {
    get windowCountTitle() {
        return this.translateExternalDamageKey(WINDOW_COUNT_TITLE);
    }
};
WindowCount = __decorate([
    Component({ components: { UiIncremental } })
], WindowCount);
export default WindowCount;
